<template>
    <div class="container">
      <div class="content">
        <button @click="redirectToLogin">Login with AWS Cognito</button>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    setup() {
      const redirectToLogin = () => {
        const loginUrl = 'https://riskypaw.auth.us-east-2.amazoncognito.com/oauth2/authorize?client_id=3v9c1k5ivrajc38f6sssoc1op3&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fmeow.riskypaws.com%2Fdashboard';
        window.location.href = loginUrl;
      };
  
      return {
        redirectToLogin,
      };
    },
  };
  </script>

   
   <style scoped>
  .container {
   background-color: #4A148C; 
   color: black;
   padding: 20px;
   border-radius: 20px;
   display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 300px;
    max-width: 800px; /* Set a maximum width */
    align-items: center; /* Centered alignment */
    margin: auto; /* Center the container on the page */
    margin-top: 0; /* Adjusted as per your requirement */
  }
  
  .content {
   background-color: white;
   padding: 20px;
   border-radius: 10px;
   color: black;
  }
   </style>
   